import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

/**
 * BillDiscountNotes — Bill discount %, Flat Total and Notes block.
 *
 * Matches the exact card layout used inside NewSaleDialog.jsx (left column of
 * the 2-column "discounts | payments" grid). Parent owns all state.
 * 
 * FLAT TOTAL: When entered, this becomes the final bill total and the 
 * AUTO ROUND OFF adjusts accordingly (flatTotal - subtotalBeforeRoundoff).
 */
export default function BillDiscountNotes({
  billDiscountPct,
  setBillDiscountPct,
  flatTotal,
  setFlatTotal,
  totalBeforeRoundoff,
  notes,
  setNotes,
}) {
  return (
    <div className="rounded-lg border border-[hsl(var(--border))] bg-white shadow-sm p-3 space-y-2" data-testid="sale-bill-discount-notes">
      <div className="grid grid-cols-2 gap-2">
        <div>
          <Label className="text-[10px] uppercase tracking-wider text-muted-foreground">Bill Disc %</Label>
          <Input
            type="number"
            step="0.01"
            min={0}
            max={100}
            value={billDiscountPct || ""}
            onChange={(e) => setBillDiscountPct(parseFloat(e.target.value || "0"))}
            className="mt-1 font-mono-data h-8 text-right text-xs"
            placeholder=""
            data-testid="sale-bill-disc"
          />
        </div>
        <div>
          <Label className="text-[10px] uppercase tracking-wider text-muted-foreground">Flat Total</Label>
          <Input
            type="number"
            step="1"
            min={0}
            value={flatTotal || ""}
            onChange={(e) => {
              const val = e.target.value;
              setFlatTotal(val === "" ? 0 : parseFloat(val));
            }}
            className="mt-1 font-mono-data h-8 text-right text-xs"
            placeholder=""
            data-testid="sale-flat-total"
          />
          {flatTotal > 0 && totalBeforeRoundoff > 0 && (
            <div className="text-[9px] text-muted-foreground mt-0.5 text-right">
              Round off: {flatTotal >= totalBeforeRoundoff ? "+" : ""}{(flatTotal - totalBeforeRoundoff).toFixed(2)}
            </div>
          )}
        </div>
      </div>
      <div>
        <Label className="text-[10px] uppercase tracking-wider text-muted-foreground">Notes</Label>
        <Textarea
          rows={2}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          className="mt-1 text-xs resize-none min-h-[44px]"
          placeholder="Optional remarks…"
          data-testid="sale-notes"
        />
      </div>
    </div>
  );
}
